import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Welcome to the Beaumont Single Public Service Pension Scheme',
  description: 'Pension Management ',
  keywords: 'nurse, shift, availability, consultants, managers, approval',
};

export default Meta;
